import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=3a86191f&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=3a86191f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a86191f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a86191f')) {
      api.createRecord('3a86191f', component.options)
    } else {
      api.reload('3a86191f', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=3a86191f&scoped=true", function () {
      api.rerender('3a86191f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotFound.vue"
export default component.exports